/**
 * @generated SignedSource<<6d39a0c2462d19df68c0191f4833efd7>>
 * @relayHash d788a2aeb0fae4e4d80ce25d45d7e74f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fdf7c38cb5d05b42232405fd538e660889cd2b346e28cb4ec030b80fd1714083

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookListQuery } from './PlaybookListQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fdf7c38cb5d05b42232405fd538e660889cd2b346e28cb4ec030b80fd1714083",
    "metadata": {},
    "name": "PlaybookListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
